var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import NumberFormat from 'react-number-format';
import { useDispatch, useSelector } from "react-redux";
import { cashoutAmountUpdate, estimatedHomeValueUpdate, loanAmountTotalUpdate, ShowButtons } from "../store/actions";

import { UserSession } from 'usersession';

export default function LoanAmount() {
    var userSession = new UserSession();

    var _useState = useState(""),
        _useState2 = _slicedToArray(_useState, 2),
        estimatedValue = _useState2[0],
        setEstimatedValue = _useState2[1];

    var _useState3 = useState(""),
        _useState4 = _slicedToArray(_useState3, 2),
        loanBalance = _useState4[0],
        setLoanBalance = _useState4[1];

    var _useState5 = useState(""),
        _useState6 = _slicedToArray(_useState5, 2),
        cashout = _useState6[0],
        setCashout = _useState6[1];

    var dispatch = useDispatch();
    var evalue = useSelector(function (state) {
        return state.nameReducer.estimatedHomeValue;
    });
    var lbalance = useSelector(function (state) {
        return state.nameReducer.loanAmount;
    });
    var cashoutAmount = useSelector(function (state) {
        return state.nameReducer.cashoutAmount;
    });

    useEffect(function () {
        dispatch(ShowButtons(false));
        document.getElementById("next-button").disabled = false;

        setEstimatedValue(evalue);
        setLoanBalance(lbalance);
        setCashout(cashoutAmount);

        userSession.setEstimatedValue(evalue);
        userSession.setCurrentLoanBalance(lbalance);
        userSession.setCashOutAmount(cashoutAmount);

        if (estimatedValue && loanBalance && cashout) dispatch(ShowButtons(true));
    }, [estimatedValue, loanBalance, cashout]);

    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            Row,
            { className: 'd-flex justify-content-center text-left pt-1 adjust_mobile_width' },
            React.createElement(
                Form.Group,
                { as: Col, lg: 8 },
                React.createElement(
                    'h4',
                    { className: 'p-0' },
                    'Current loan balance (How much do you currently owe)?'
                ),
                React.createElement(NumberFormat, { className: 'form-control', placeholder: 'Current Loan Balance',
                    value: loanBalance, displayType: 'input',
                    thousandSeparator: true, prefix: '$', decimalScale: 2,
                    fixedDecimalScale: true,
                    onValueChange: function onValueChange(values) {
                        setLoanBalance(values.value);
                        dispatch(loanAmountTotalUpdate(values.value));
                    } })
            ),
            React.createElement(
                Form.Group,
                { as: Col, lg: 8 },
                React.createElement(
                    'h4',
                    null,
                    'Cash out amount'
                ),
                React.createElement(NumberFormat, { className: 'form-control', placeholder: 'Cash-Out Amount',
                    value: cashout, displayType: 'input',
                    thousandSeparator: true, prefix: '$',
                    decimalScale: 2, fixedDecimalScale: true,
                    onValueChange: function onValueChange(values) {
                        setCashout(values.value);
                        dispatch(cashoutAmountUpdate(values.value));
                    } })
            ),
            React.createElement(
                Form.Group,
                { as: Col, lg: 8 },
                React.createElement(
                    'h4',
                    null,
                    'Estimated home value'
                ),
                React.createElement(NumberFormat, { className: 'form-control',
                    placeholder: 'Estimated Home Value',
                    value: estimatedValue, displayType: 'input',
                    thousandSeparator: true, prefix: '$',
                    decimalScale: 0, fixedDecimalScale: false,
                    onValueChange: function onValueChange(values) {
                        setEstimatedValue(values.value);
                        dispatch(estimatedHomeValueUpdate(values.value));
                    } })
            )
        )
    );
}